<template>
  <div class="tr-step-2">
    <div class="step2__highlight-card">
      <div class="highlight-header">HIGHLIGHTS</div>
      <Highlight2 />
    </div>
    <div class="tr-step-2__card">
      <v-alert text colored-border border="top" color="info">
        <div class="tr-step-2__head"><i class="light-icon-home"></i> Step:2 Housing Details</div>
      </v-alert>
      <!-- <v-switch v-model="step2.enable_surface_area_direct" label="Enable surface area directly" color="indigo"></v-switch> -->
      <!-- Only when not entering surface area directly -->
      <div v-if="!step2.enable_surface_area_direct">
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in step2.houseTypeArrObj" :key="item.type" :style="{ margin: '4px' }">
            <v-expansion-panel-header>Type {{ i + 1 }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="step-2__accordian-fields-wrap">
                <div class="step-2__accordian-fields-row">
                  <v-select :items="item.house_categories" v-model="item.selected_category" label="Select housing type" outlined dense class="housing-type__select"></v-select>
                  <v-text-field type="number" v-model="item.carpet_area" label="Carpet area of dwelling (sq. M)" outlined dense class="acc-field"> </v-text-field>
                  <v-text-field type="number" label="% Area of walls" v-model="item.area_of_walls" outlined dense clearable class="acc-field"></v-text-field>
                  <v-text-field type="number" v-model="item.no_of_du" label="No. of dwelling units (DU)" outlined dense class="acc-field"></v-text-field>
                </div>
                <hr />
                <div class="step2_calc-built-area">
                  <div class="calc-label">Built up area of dwelling <span class="units">(sq. M per DU)</span> :</div>
                  <div class="calc-value">{{ item.built_up_area }}</div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div>
          <v-btn class="ma-2" outlined color="indigo" dense @click="addNewHouseType">
            <v-icon left> mdi-plus </v-icon>
            Add new type
          </v-btn>
          <v-btn class="ma-2" outlined color="red" dense @click="removeHouseType">
            <v-icon left> mdi-delete </v-icon>
            Remove type
          </v-btn>
        </div>
        <div class="step-2__calc-fields-wrap">
          <v-text-field type="number" label="Loading factor (%)" outlined dense clearable v-model="schema.inputs.step2.commonFields.loading_factor" class="acc-field"></v-text-field>
          <v-text-field type="number" label="No. of floors" outlined dense class="acc-field" v-model="schema.inputs.step2.commonFields.no_of_floors"></v-text-field>
          <v-text-field type="number" label="Floor height (m)" outlined dense class="acc-field" v-model="schema.inputs.step2.commonFields.floor_height"></v-text-field>
        </div>
        <div class="step-2__summary">
          <div class="summary-head">Summary:</div>
          <div class="summary-block__wrap">
            <div class="summary-field__row">
              <div class="sumarry-field__label">Area of floor plate <span class="units">(sq. M)</span></div>
              <div class="summary-field__value">{{ step2.summary_step2.area_floor_plate }}</div>
            </div>
            <div class="summary-field__row">
              <div class="sumarry-field__label">Total built-up area <span class="units">(sq.M)</span></div>
              <div class="summary-field__value">{{ step2.summary_step2.total_built_up_area }}</div>
            </div>
            <div class="summary-field__row">
              <div class="sumarry-field__label">Wall cross-sectional area <span class="units">(sq.M)</span></div>
              <div class="summary-field__value">{{ step2.summary_step2.wall_cross_sectional_area }}</div>
            </div>
            <div class="summary-field__row">
              <div class="sumarry-field__label">Surface area walls <span class="units">(sq.M)</span></div>
              <div class="summary-field__value">{{ summarySurfaceAreaWall }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-else>
        <div>
          <LvInput label="Enter Surface area" type="number" v-model="step2.surface_area_direct"> </LvInput>
          <div class="step-2__summary">
            <div class="summary-head">Summary:</div>
            <div class="summary-block__wrap">
              <div class="summary-field__row">
                <div class="sumarry-field__label">Surface Area Walls(t-250mm)</div>
                <div class="summary-field__value">{{ step2.surface_area_direct }} sq M</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <br />
      <hr />
      <br />
      <div class="step-2__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step1' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step3A' })">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import Highlight2 from '../highlights/Highlight2.vue';
import Result from '../Result.vue';
export default {
  components: {
    LvInput,
    Highlight2,
    Result,
  },
  data() {
    return {
      def_area_of_walls: 12,
      def_loading_factor: 25,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep2', step2);
      },
    },

    summaryTotalBuiltUp() {
      return this.step2.summary_step2.area_floor_plate * this.step2.commonFields.no_of_floors;
    },

    summarySurfaceAreaWall() {
      this.step2.summary_step2.surface_area_wall = (+(this.step2.summary_step2.wall_cross_sectional_area / 0.25) * +this.step2.commonFields.floor_height).toFixed(2);
      return this.step2.summary_step2.surface_area_wall;
    },
    //    builtUpArea(){
    //      for(let i=0; i<=this.schema.inputs.step2.houseTypeArrObj.length-1; i++){

    //       this.schema.inputs.step2.houseTypeArrObj[i].built_up_area=this.schema.inputs.step2.houseTypeArrObj[i].carpet_area/(1-(this.schema.inputs.step2.houseTypeArrObj[i].area_of_walls/100));
    //      }
    //       // return this.schema.inputs.step2.houseTypeArrObj[i].built_up_area;

    // }
  },
  beforeUpdate() {
    this.builtUpArea();
    this.summaryAreaFloorPlate();
    this.summaryWallCrossArea();
  },
  methods: {
    builtUpArea() {
      for (let j = 0; j <= this.step2.houseTypeArrObj.length - 1; j++) {
        this.step2.houseTypeArrObj[j].built_up_area = (this.step2.houseTypeArrObj[j].carpet_area / (1 - this.step2.houseTypeArrObj[j].area_of_walls / 100)).toFixed(2);
      }
    },
    summaryAreaFloorPlate() {
      let productBuiltDU = 0;
      let sumBuiltDU = 0;
      let totalFloorPlateArea = 0;

      for (let i = 0; i <= this.step2.houseTypeArrObj.length - 1; i++) {
        productBuiltDU = +(this.step2.houseTypeArrObj[i].built_up_area * this.step2.houseTypeArrObj[i].no_of_du);
        sumBuiltDU = productBuiltDU + +sumBuiltDU;
      }

      totalFloorPlateArea = sumBuiltDU + (this.step2.commonFields.loading_factor / 100) * sumBuiltDU;
      this.step2.summary_step2.area_floor_plate = totalFloorPlateArea.toFixed(2);
      //total built up area
      this.step2.summary_step2.total_built_up_area = (this.step2.summary_step2.area_floor_plate * this.step2.commonFields.no_of_floors).toFixed(2);
    },
    summaryWallCrossArea() {
      let localWallCrossArea = 0;
      let builtSubCarpProDu = 0;
      for (let i = 0; i <= this.step2.houseTypeArrObj.length - 1; i++) {
        builtSubCarpProDu = +((this.step2.houseTypeArrObj[i].built_up_area - this.step2.houseTypeArrObj[i].carpet_area) * this.step2.houseTypeArrObj[i].no_of_du) * this.step2.commonFields.no_of_floors;
        localWallCrossArea = builtSubCarpProDu + +localWallCrossArea;
      }
      this.step2.summary_step2.wall_cross_sectional_area = localWallCrossArea.toFixed(2);
    },
    addNewHouseType() {
      let typesCount = this.step2.houseTypeArrObj.length;
      let newHouseType = {
        type: `Type ${typesCount + 1}`,
        house_categories: ['EWS', 'MIG', 'LIG', 'HIG'],
        selected_category: '',
        carpet_area: 0,
        area_of_walls: 12,
        built_up_area: 0,
        no_of_du: 0,
      };
      this.step2.houseTypeArrObj.splice(typesCount, 0, newHouseType);
    },
    removeHouseType() {
      let typesCount = this.step2.houseTypeArrObj.length;
      if (typesCount !== 1) {
        this.step2.houseTypeArrObj.splice(typesCount - 1, 1);
      }
    },
  },
};
</script>

<style lang="scss">
.tr-step-2 {
  padding: 32px;
  width: 100%;
  height: 100%;
}
.step2__highlight-card {
  background-color: #fff;
  margin: 24px 0px;
  // padding: 38px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}

.tr-step-2__head {
  margin: 0px 0px 18px 0;
  font-size: 28px;
  // color: #343f4b;
  text-align: center;
  i {
    font-size: 28px;
  }
}
.tr-step-2__card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 28px;
  margin-bottom: 28px;

  // width: 80%;
}
.step-2__accordian-fields-wrap {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .step-2__accordian-fields-row {
    display: flex;
    justify-items: space-around;

    flex-wrap: wrap;

    .acc-field {
      margin: 0 4px;
    }
  }
}
.housing-type__select {
  width: 100%;
}
.step-2__calc-fields-wrap {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  .acc-field {
    margin: 0 4px;
  }
}
.step2_calc-built-area {
  display: flex;
  .calc-label {
    padding: 2px 8px 2px 8px;
    color: #343f4b;

    font-size: 16px;
  }
  .calc-value {
    padding: 2px 8px 2px 8px;
    text-align: center;
    background-color: #b3f5db;
    color: #343f4b;
    font-size: 16px;
    border-radius: 4px;
  }
}
.step-2__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.units {
  font-size: 11px;
  opacity: 0.7;
}
.step-2__next-back-row {
  display: flex;
  justify-content: space-between;
}
</style>
